const initial_state = {
    initial_financial_rent: 0,
    initial_vehicle_tco: 0,
    initial_company_tco: 0,
    initial_taxes_amount: 0,
};

const reducerInitialTco = (state = initial_state, action) => {
    switch (action.type) {
        case "UPDATE_INITIAL_TCO":
            let next_state = { ...state };
            next_state[action.payload.target] = Math.round(action.payload.value);
            return next_state;

        default:
            return state;
    }
};

export default reducerInitialTco;



// WEBPACK FOOTER //
// ./src/reducers/reducer-initial-tco.js